import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { XStackContainer } from "../../Containers";
import { ObjectDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { BarChartFormControl } from "../Web/BarChartFormControl";
import { chartNonSeries } from "../Testing/ChartSameple";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { FormRuntime } from "../../FormRuntime";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

function getUI(): { form: FormConfiguration; control: BarChartFormControl } {
    let ui = new FormConfiguration();
    let dataDef = ui.getInputDefinition();

    const chartDataDef = new ObjectDataDefinition("invoiceByMonth");
    chartDataDef.list = true;
    const labelDef = new StringDataDefinition("label");
    const valueDef = new NumberDataDefinition("value");
    chartDataDef.fields.push(labelDef);
    chartDataDef.fields.push(valueDef);
    dataDef.fields.push(chartDataDef);

    const values = chartNonSeries;

    dataDef.value["invoiceByMonth"] = values;

    ui.inputData = dataDef;

    let container = new XStackContainer();
    const chart = new BarChartFormControl();
    container.add(chart);
    ui.add(container);

    return { form: ui, control: chart };
}

export const BarChartStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.showLegend = true;

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Legend",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.render3D = true;

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "3d",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.cursor = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Cursor",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.showTooltip = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Tooltip",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.xAxisLabel = "Month";
            ui.control.yAxisLabel = "Amount";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Axis Label",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.showXYAxis = false;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Hide XY Axis",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.setLowerBounds = true;
            ui.control.lowerBounds = 0;
            ui.control.setUpperBounds = true;
            ui.control.upperBounds = 5000;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Upper and Lower Bounds",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.dataName = "invoiceByMonth";
            ui.control.label = "Bar Chart";
            ui.control.numberFormatter = "BigNumber";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Number Formatter",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Bar Chart";
            ui.control.allowSeries = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Multiple Series",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Bar Chart";
            ui.control.allowSeries = true;
            ui.control.stackBars = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Multiple Series (stacked)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Bar Chart";
            ui.control.allowSeries = true;
            ui.control.render3D = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Multiple Series (3d)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Bar Chart";
            ui.control.allowSeries = true;
            ui.control.stackBars = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Multiple Series (non nested data)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Bar Chart";
            ui.control.allowSeries = true;
            ui.control.colorType = "Mono";
            ui.control.color = UIStyleConstants.TEXT_COLOR_DEFAULT;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Multiple Series (mono)",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Bar Chart";
            ui.control.allowSeries = true;
            ui.control.colorType = "Custom";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Multiple Series (custom color) - ??? HOW DO YOU SET COLOR",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Bar Chart";
            ui.control.allowSeries = true;
            ui.control.cursor = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Bar Chart",
        "With Multiple Series (with cursor) - ??? HOW DO YOU SET COLOR",
    ),
];
